import { Filters } from "components/filters/filters.component"
import { Page } from "components/page/page.component"
import { View } from "components/view/view.component"
import { Text } from 'components/text/text.component'
import style from './graphic.module.css'
import { difference, getDaysBefore, getMinutesAfter, toDateMonthYearHourMinuteString } from "utils/date.util"
import { FilterType } from "model/filter.model"
import { useEffect, useState } from "react"
import { useGetRestaurantOccupationGraphicDataApi } from "api/graphics.api"
import { Skeleton } from "components/skeleton"
import { OccupationCountGraphicComponent } from "components/graphic/santander/occupation.count.graphic.component"
import { MAX_SANTANDER_RESTAURANT_CAPACITY } from "data/santander.data"

type GraphicPageProps = {
    companyId?: string,
    indicatorId?: string
}
export function RestaurantGraphicPage({companyId}: GraphicPageProps){

    const {data, get, loading} = useGetRestaurantOccupationGraphicDataApi()
    const [filter, setFilter] = useState<FilterType | undefined>(undefined)
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)

    function handleOnFilterChange(filter: FilterType){
        setErrorMessage(undefined)
        setFilter(filter)
    }

    useEffect(()=>{
        if(!companyId) return
        if(!filter?.startDate) return
        if(!filter?.endDate) return
        if(!filter?.rooms) return
        if(difference(filter.endDate, filter.startDate) >= 7) return setErrorMessage('O período máximo é de 7 dias')
        const _filter = {
            rooms: filter.rooms,
            startDate: filter.startDate,
            endDate: filter.endDate
        }
        get(_filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[filter, companyId])

    function separateDataByHours(data: any[], hours: number): any[][]{
        // return [data]
        const sortedData = data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        const groups: any[][] = []
        let currentGroup: any[] = []
        let groupStartTime: number | null = null

        sortedData.forEach(item => {
            const itemTime = new Date(item.date).getTime()
            if(groupStartTime === null){
                groupStartTime = itemTime
            }
            if(itemTime - groupStartTime <= hours * 60 * 60 * 1000){
                currentGroup.push(item)
            } else {
                groups.push(currentGroup)
                currentGroup = [item]
                groupStartTime = itemTime
            }
        })
        if(currentGroup.length > 0){
            groups.push(currentGroup)
        }
        return groups
    }

    return <Page menu header title="Gráfico Ocupação de Restaurante">
        <View className={style.Content}>
            <Filters 
                companyId={companyId} 
                // showBuildings
                // onlyOneBuilding
                onlyEnableBuildings
                // showAreas
                // onlyOneArea
                onlyEnableAreas
                showRooms 
                roomsTitle="Restaurante"
                hideAreaFromRoomsOptions
                hideBuildingFromRoomsOptions
                roomIndicatorIds={['room-occupation-count']}
                onlyOneRoom
                onlyEnableRooms
                showStartDate 
                showEndDate 
                dateType='datetime' 
                initialStartDate={getMinutesAfter(getDaysBefore( new Date(), 1), 1)} 
                initialEndDate={new Date()}
                onChange={handleOnFilterChange}
                maxDateInterval={7 * 24 * 60}// max 7 days 24 hours
            />
            {loading 
            ? <Skeleton className={style.GraphicContainer} color='bg3' />
            :<View className={style.GraphicContainer}>
                {!filter?.rooms || filter.rooms.length <= 0
                ? <Text type='h3'>Selecione ao menos um restaurante</Text>
                : !filter.startDate || !filter.endDate
                ? <Text type='h3'>Selecione as datas</Text>
                : difference(filter.endDate, filter.startDate) >= 7
                ? <Text type='h3'>Selecione o período máximo de 7 dias</Text>
                : errorMessage
                ? <Text type='h3'>{errorMessage}</Text>
                : !data || data.length <= 0
                ? <Text type='h3'>Nenhum dado encontrado</Text>
                :<View className={style.GraphicContent}>
                    {separateDataByHours(data, 24).map(
                        (group, index) => <View key={index} className={style.GraphicArea}>
                        <OccupationCountGraphicComponent 
                            labels={group.map(_ => toDateMonthYearHourMinuteString(_.date)) ?? []} 
                            restauranteValues={group.map(_ => _.value)} 
                            max={filter?.rooms?.[0]?.name === 'Restaurante' ? 700 : filter?.rooms?.[0]?.name === 'Sala de Marmitas' ? 30 : undefined} 
                            showReferenceLines={filter?.rooms?.[0]?.name === 'Restaurante' ? true : false}
                            showReferenceLinesLegends={filter?.rooms?.[0]?.name === 'Restaurante' ? true : false}
                            referenceValue={MAX_SANTANDER_RESTAURANT_CAPACITY}
                            disableDatalabels
                        />
                    </View>)}
                </View>}
            </View>
            }
        </View>
    </Page>
}